import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/kanghong/logo-2.png'
import _imports_1 from '../assets/kanghong/logo-3.png'
import _imports_2 from '../assets/kanghong/logo-4.png'
import _imports_3 from '../assets/kanghong/logo-5.png'
import _imports_4 from '../assets/kanghong/logo-1.png'
import _imports_5 from '../assets/kanghong/icon.png'


const _hoisted_1 = { class: "lk-portal-kanghong-login" }
const _hoisted_2 = { class: "lk-portal-kanghong-login-container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"lk-portal-kanghong-login-container-top\"><div class=\"lk-portal-kanghong-login-container-top-wrap\"><div class=\"lk-portal-kanghong-login-container-top-wrap-left\"><div class=\"icon\"><img src=\"" + _imports_0 + "\"></div><div class=\"icon\"><img src=\"" + _imports_1 + "\"></div><div class=\"icon\"><img src=\"" + _imports_2 + "\"></div></div><div class=\"lk-portal-kanghong-login-container-top-wrap-right\"><div class=\"icon\"><img src=\"" + _imports_3 + "\"></div></div></div></div>", 1)
const _hoisted_4 = { class: "lk-portal-kanghong-login-container-middle" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"lk-portal-kanghong-login-container-middle-left\"><div class=\"icon\"><img src=\"" + _imports_4 + "\"></div><div class=\"icon\"><img src=\"" + _imports_5 + "\"></div></div>", 1)
const _hoisted_6 = { class: "lk-portal-kanghong-login-container-middle-right" }
const _hoisted_7 = { class: "embed-wrapper" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "lk-portal-kanghong-login-footer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lk-portal-kanghong-login-footer-content" }, [
    /*#__PURE__*/_createElementVNode("p", null, "尊敬的眼科同道："),
    /*#__PURE__*/_createElementVNode("p", null, " 随着中国的糖尿病患病率增加，糖尿病视网膜病变患病率逐步增加，已成为20-74岁人群视力受损的最重要原因。为促进在糖尿病视网膜病变上的规范化诊疗，更好地为患者提供高水平的医疗诊治服务，同时产生高质量的真实世界循证证据，国家眼部疾病临床医学研究中心携手中国初级卫生保健基金会、中华医学会国际医学交流基金会发起“糖尿病视网膜病变临床及研究中心”项目。 "),
    /*#__PURE__*/_createElementVNode("p", null, " 本项目于2022年4月正式启动，将由国家眼部疾病临床医学研究中心进行指导，由中国初级卫生保健基金会与中华国际医学交流基金会负责具体执行相关工作。欢迎各位眼科专家积极参与，踊跃报名，共建糖尿病视网膜病变专科联盟，建立全国医疗服务与培训体系，共享共建医疗公益平台，让患者享受院内外全程的疾病关爱，同时支持和推动我国医学学术研究与发展，促进医学学术的转化。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "lk-portal-kanghong-login-footer-record" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" 零氪科技提供技术支持 ©2020 LinkDoc "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://beian.miit.gov.cn/",
        target: "_blank"
      }, "京ICP备15001843号-1")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginBox = _resolveComponent("LoginBox")!
  const _component_PrivateLogin = _resolveComponent("PrivateLogin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass({
                'embed-passport-login': true,
                'private-passport-login': _ctx.state.isInHospEnv && _ctx.isNuc
              }),
              id: "embed-passport-login"
            }, [
              (_ctx.state.isInHospEnv && _ctx.isNuc)
                ? (_openBlock(), _createBlock(_component_LoginBox, {
                    key: 0,
                    loginBoxOutStyle: false,
                    showForget: ""
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.isInHospEnv && !_ctx.isNuc)
                ? (_openBlock(), _createBlock(_component_PrivateLogin, { key: 1 }))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ])
    ]),
    _hoisted_8
  ]))
}